import type { Product, Variant } from '@scayle/storefront-nuxt'

type AttributeValue = string | number | null | undefined

export const getAdvancedAttributeFirstValue = (
  object: Product | Variant | null,
  key: string,
): AttributeValue => {
  return object?.advancedAttributes?.[key]?.values?.[0]?.fieldSet?.[0]?.[0]
    ?.value
}

/**
 * The product description shown on the PDP, preferring the web-optimised
 * "Webtext" (`webtext`) and falling back to the OMN "Standardtext"
 * (`standardtext`) when no Webtext exists. See ECOM-2650.
 *
 * `longdescription` is not the Webtext despite its name — the OMN import copies
 * the Standardtext into it — but it is the only text some products carry, so it
 * stays as a middle fallback.
 *
 * Empty strings count as "not delivered", so blank values also fall through.
 */
export const getProductDescription = (
  product: Product | null,
): AttributeValue => {
  return (
    getAdvancedAttributeFirstValue(product, 'webtext') ||
    getAdvancedAttributeFirstValue(product, 'longdescription') ||
    getAdvancedAttributeFirstValue(product, 'standardtext')
  )
}
